import {
  Avatar, AvatarProps, ICON_DOMAIN, ICON_FOREST_OUTLINE,
} from '@doveit/bricks';
import React from 'react';
import { Property } from '../../../providers/api/dtos';
import {
  NonResidentialPropertyType, NonResidentialPropertyTypeValue,
} from '../../../domain/types/propertyType';
import { ThemeIcons } from '../../../theme/icons';

export type PropertyAvatarProps = Pick<AvatarProps, 'size' | 'placeholder'> & {
  propertyType?: Property['propertyType'],
  isPersonal?: boolean,
};

export const PropertyAvatar: React.FC<PropertyAvatarProps> = ({
  propertyType,
  isPersonal = true,
  ...rest
}) => {
  const placeholder = React.useMemo(() => {
    if (!propertyType) return ICON_DOMAIN;

    if (Object.values(NonResidentialPropertyTypeValue).includes(propertyType as NonResidentialPropertyType)) {
      return ICON_FOREST_OUTLINE;
    }

    return ICON_DOMAIN;
  }, [propertyType]);

  return (
    <Avatar
      {...rest}
      icon={!isPersonal ? ThemeIcons.DOVE : undefined}
      placeholder={placeholder}
    />
  );
};

export default PropertyAvatar;
